import { Component, Input } from '@angular/core';

@Component({
  selector: 'itl-desktop-detail-item',
  templateUrl: './desktop-detail-item.component.html',
  styleUrls: ['./desktop-detail-item.component.scss'],
  standalone: false,
})
export class DesktopDetailItemComponent {
  @Input() icon: string;
  @Input() iconColor: string;
  @Input() title: string;
}
